module.exports = "/fonts/icomoon.svg?59bf56813859b7c68b609bb68e4edad0";